import { extractText, textToDoc } from "@shared/tiptap-doc";

/** Current content of a candidacy field as a tiptap JSON string: the stored doc,
 * or legacy plaintext converted on the fly (pre-backfill rows). Used to seed the
 * editor so an unedited save round-trips existing content. */
export const docOrLegacy = (docJson: string | null, legacy: string | null): string =>
  docJson ?? JSON.stringify(textToDoc(legacy ?? ""));

/** True when a tiptap JSON string carries any visible text (drives submit gating). */
export const docHasText = (docJson: string): boolean => {
  try {
    return extractText(JSON.parse(docJson)).trim().length > 0;
  } catch {
    return false;
  }
};
